var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "table",
    {
      staticClass: "default",
    },
    [
      _c("caption", [
        _vm._v(
          "\n        " + _vm._s(_vm.$gettext("Veranstaltungen")) + "\n        "
        ),
        _vm.isLoading
          ? _c(
              "span",
              {
                staticClass: "actions",
              },
              [
                _c("img", {
                  attrs: {
                    src: _vm.loadingIndicator,
                    width: "20",
                    height: "20",
                    title: _vm.$gettext("Daten werden geladen"),
                  },
                }),
              ]
            )
          : _vm.coursesCount > 0
          ? _c(
              "span",
              {
                staticClass: "actions",
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.coursesCount + " " + _vm.$gettext("Veranstaltungen")
                    ) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "colgroup",
        [
          _vm.showComplete ? _c("col") : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.sortedActivatedFields, function (activeField) {
            return _c("col", {
              key: "col-".concat(activeField),
              style: {
                width:
                  activeField === "contents" && _vm.contentWidth !== null
                    ? "".concat(_vm.contentWidth, "px")
                    : null,
              },
            })
          }),
          _vm._v(" "),
          _c("col"),
        ],
        2
      ),
      _vm._v(" "),
      _c("thead", [
        _c(
          "tr",
          {
            staticClass: "sortable",
          },
          [
            _vm.showComplete
              ? _c(
                  "th",
                  {
                    class:
                      _vm.sort.by === "completion"
                        ? "sort" + _vm.sort.direction.toLowerCase()
                        : "",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "course-completion",
                        attrs: {
                          title: _vm.$gettext("Bearbeitungsstatus"),
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.changeSort("completion")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Bearbeitungsstatus")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.sortedActivatedFields, function (activeField) {
              return _c(
                "th",
                {
                  key: "field-".concat(activeField),
                  class:
                    _vm.sort.by === activeField
                      ? "sort" + _vm.sort.direction.toLowerCase()
                      : "",
                },
                [
                  !_vm.unsortableFields.includes(activeField)
                    ? _c(
                        "a",
                        {
                          attrs: {
                            href: "#",
                            title:
                              _vm.sort.by === activeField &&
                              _vm.sort.direction === "ASC"
                                ? _vm.$gettextInterpolate(
                                    "Sortiert aufsteigend nach %{field}",
                                    {
                                      field: _vm.fields[activeField],
                                    },
                                    true
                                  )
                                : _vm.sort.by === activeField &&
                                  _vm.sort.direction === "DESC"
                                ? _vm.$gettextInterpolate(
                                    "Sortiert absteigend nach %{ field } ",
                                    {
                                      field: _vm.fields[activeField],
                                    },
                                    true
                                  )
                                : _vm.$gettextInterpolate(
                                    "Sortieren nach %{ field }",
                                    {
                                      field: _vm.fields[activeField],
                                    },
                                    true
                                  ),
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.changeSort(activeField)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.fields[activeField]) +
                              "\n                "
                          ),
                        ]
                      )
                    : [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.fields[activeField]) +
                            "\n                "
                        ),
                      ],
                ],
                2
              )
            }),
            _vm._v(" "),
            _c(
              "th",
              {
                staticClass: "actions",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$gettext("Aktion")) +
                    "\n                "
                ),
                _c("studip-action-menu", {
                  staticClass: "filter",
                  attrs: {
                    title: _vm.$gettext("Darstellungsfilter"),
                    items: _vm.availableFields,
                  },
                  on: {
                    toggleActiveField: _vm.toggleActiveField,
                  },
                }),
              ],
              1
            ),
          ],
          2
        ),
        _vm._v(" "),
        _vm.buttons.top
          ? _c("tr", [
              _c("th", {
                staticStyle: {
                  "text-align": "right",
                },
                attrs: {
                  colspan: _vm.colspan,
                },
                domProps: {
                  innerHTML: _vm._s(_vm.buttons.top),
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        {
          class: {
            loading: _vm.isLoading,
          },
        },
        [
          _vm._l(_vm.sortedCourses, function (course) {
            return _c(
              "tr",
              {
                key: course.id,
                class: course.id === _vm.currentLine ? "selected" : "",
                on: {
                  click: function click($event) {
                    _vm.currentLine = course.id
                  },
                },
              },
              [
                _vm.showComplete
                  ? _c("td", [
                      _c(
                        "button",
                        {
                          staticClass: "course-completion undecorated",
                          attrs: {
                            href: _vm.getURL(
                              "dispatch.php/admin/courses/toggle_complete/" +
                                course.id
                            ),
                            "data-course-completion": course.completion,
                            title:
                              (course.completion > 0
                                ? course.completion == 1
                                  ? _vm.$gettext(
                                      "Veranstaltung in Bearbeitung."
                                    )
                                  : _vm.$gettext("Veranstaltung komplett.")
                                : _vm.$gettext("Veranstaltung neu.")) +
                              " " +
                              _vm.$gettext("Klicken zum Ändern des Status."),
                          },
                          on: {
                            click: function click($event) {
                              $event.preventDefault()
                              return _vm.toggleCompletionState(course.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$gettext("Bearbeitungsstatus ändern")
                              ) +
                              "\n                "
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.sortedActivatedFields, function (active_field) {
                  return _c(
                    "td",
                    {
                      key: active_field,
                    },
                    [
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(course[active_field]),
                        },
                      }),
                      _vm._v(" "),
                      active_field === "name" &&
                      _vm.getChildren(course).length > 0
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: "",
                              },
                              on: {
                                click: function click($event) {
                                  $event.preventDefault()
                                  return _vm.toggleOpenChildren(course.id)
                                },
                              },
                            },
                            [
                              _c("studip-icon", {
                                staticClass: "text-bottom",
                                attrs: {
                                  shape:
                                    _vm.open_children.indexOf(course.id) === -1
                                      ? "add"
                                      : "remove",
                                },
                              }),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$gettextInterpolate(
                                      _vm.$gettext(
                                        "%{ n } Unterveranstaltungen"
                                      ),
                                      {
                                        n: _vm.getChildren(course).length,
                                      }
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("td", {
                  staticClass: "actions",
                  domProps: {
                    innerHTML: _vm._s(course.action),
                  },
                }),
              ],
              2
            )
          }),
          _vm._v(" "),
          _vm.coursesCount === 0 && _vm.coursesLoaded
            ? _c("tr", [
                _c(
                  "td",
                  {
                    attrs: {
                      colspan: _vm.colspan,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Keine Ergebnisse")) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.coursesCount > 0 && _vm.sortedCourses.length === 0
            ? _c("tr", [
                _c(
                  "td",
                  {
                    attrs: {
                      colspan: _vm.colspan,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$gettextInterpolate(
                            _vm.$gettext(
                              "%{ n } Veranstaltungen entsprechen Ihrem Filter. Schr\xE4nken Sie nach M\xF6glichkeit die Filter weiter ein."
                            ),
                            {
                              n: _vm.coursesCount,
                            }
                          )
                        ) +
                        "\n                "
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "",
                        },
                        on: {
                          click: function click($event) {
                            $event.preventDefault()
                            return _vm.loadCourses({
                              withoutLimit: true,
                            })
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Alle anzeigen")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.coursesLoaded
            ? _c("tr", [
                _c(
                  "td",
                  {
                    attrs: {
                      colspan: _vm.colspan,
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Daten werden geladen ...")) +
                        "\n            "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _vm.buttons.bottom
        ? _c("tfoot", [
            _c("tr", [
              _c("td", {
                staticStyle: {
                  "text-align": "right",
                },
                attrs: {
                  colspan: _vm.colspan,
                },
                domProps: {
                  innerHTML: _vm._s(_vm.buttons.bottom),
                },
              }),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }